var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-20 -20 291.42 261.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.93,81c19.65,38.94,44.24,134-74.51,134S30.26,119.45,49.91,81C68.64,44.37,68,6.5,124.42,6.5S180.4,44.27,198.93,81Z",
    fill: "white",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.53,18.8s23.62-11.94,46.35,12.25,57.64,78.8-2,79.71",
    fill: "white",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.71,15.85q-1.84,1.24-3.53,2.63C79.13,16.75,58,9.3,37.54,31.05c-22.58,24-57.2,78.12.89,79.68C26.22,154.8,30.16,215,124.42,215c60.89,0,84.09-25,89.6-54.61C147.54,147.71,103.66,67.78,86.71,15.85Z",
    fill: "#B8D5AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.93,81c19.65,38.94,44.24,134-74.51,134S30.26,119.45,49.91,81C68.64,44.37,68,6.5,124.42,6.5S180.4,44.27,198.93,81Z",
    fill: "none",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.89,18.8S60.26,6.86,37.54,31.05s-57.65,78.8,2,79.71",
    fill: "none",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.53,18.8s23.62-11.94,46.35,12.25,57.64,78.8-2,79.71",
    fill: "none",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.32,165.71l11.9-12.21a13.17,13.17,0,0,0-9.43-22.36h-20a13.9,13.9,0,0,0-10,23.6l10.7,11A11.72,11.72,0,0,0,132.32,165.71Z",
    fill: "none",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.16,
    cy: 92.81,
    r: 8.82,
    fill: "#190740"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.68,
    cy: 92.81,
    r: 8.82,
    fill: "#190740"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 123.92,
    y1: 169.25,
    x2: 123.92,
    y2: 215.03,
    fill: "none",
    stroke: "#190740",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogIcon);
export default __webpack_public_path__ + "static/media/DogIcon.1b622c52e9448c94393bfabf8d2c8dc8.svg";
export { ForwardRef as ReactComponent };